<template>
  <v-text-field
    :model-value="displayValue"
    label="Activity Time"
    variant="outlined"
    hide-details="auto"
    readonly
  >
    <v-menu
      activator="parent"
      :close-on-content-click="false"
      location="bottom"
      min-width="360"
      @update:model-value="handleMenuToggle"
    >
      <DateTimePicker v-model="model" />
    </v-menu>
  </v-text-field>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useDate } from 'vuetify'

import type { VTextField } from 'vuetify/components'
import type DateFnsUtils from '@date-io/date-fns/build/date-fns-utils'
import DateTimePicker from '@/components/common/DateTimePicker.vue'

const dateAdapter = useDate() as DateFnsUtils

const model = defineModel<string | Date | null>({
  default: null
})

const handleMenuToggle = (isOpen: boolean) => {
  // When menu opens and model is null, set to current time
  if (isOpen && !model.value) {
    model.value = new Date()
  }
}

const displayValue = computed(() => {
  if (!model.value) return ''

  // Ensure we have a valid Date object
  const date = model.value instanceof Date ? model.value : new Date(model.value as string)

  // Check if date is valid
  if (isNaN(date.getTime())) return ''

  return dateAdapter.formatByString(date, 'MMMM dd, yyyy - HH:mm')
})
</script>
